import { useState, useEffect } from 'react';

function useLocation() {
  const [currentIsoCode, setCurrentIsoCode] = useState('AU');
  const [freeShippingThreshold, setFreeShippingThreshold] = useState(100);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectCountryAndSetThreshold = async () => {
      setIsLoading(true);
      
      try {
        // Wait for Shopify object to be available
        let attempts = 0;
        while ((!window.Shopify || !window.Shopify.country) && attempts < 10) {
          await new Promise(resolve => setTimeout(resolve, 100));
          attempts++;
        }

        // Multiple detection methods with fallbacks
        let detectedCountry = 
          window.Shopify?.country ||
          window.Shopify?.checkout?.shipping_address?.country_code ||
          localStorage.getItem('user_country');
        
        // Fallback to IP detection if needed
        if (!detectedCountry) {
          try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            detectedCountry = data.country_code;
            localStorage.setItem('user_country', detectedCountry);
          } catch (error) {
            console.warn('IP detection failed:', error);
          }
        }

        if (!detectedCountry) {
          const browserLocale = navigator.language || navigator.languages[0];
          detectedCountry = browserLocale.split('-')[1];
        }
        
        const finalCountry = (detectedCountry || 'AU').toUpperCase();
        
        // Get thresholds using the new structure
        const thresholds = window.Shopify?.freeShippingThresholds || {
          AU: window.Shopify?.free_shipping_threshold_au,
          UK: window.Shopify?.free_shipping_threshold_uk,
          INTL: window.Shopify?.free_shipping_threshold_intl,
        };
        
        const threshold = thresholds[finalCountry] || thresholds.AU;
        
        // console.log('Detected country:', finalCountry);
        // console.log('Selected threshold:', threshold);

        setCurrentIsoCode(finalCountry);
        setFreeShippingThreshold(threshold);
        
      } catch (error) {
        console.error('Country detection failed:', error);
        setCurrentIsoCode('AU');
        setFreeShippingThreshold(thresholds.AU);
      } finally {
        setIsLoading(false);
      }
    };

    detectCountryAndSetThreshold();
  }, []);

  return {
    currentIsoCode,
    freeShippingThreshold,
    isLoading
  };
}

export default useLocation;